import {css} from 'lit';
export const styles = css`:host {
  --bg: var(--contrast-light);
  --bg-hover: var(--gray-000);
  --bg-active: var(--contrast-light);

  display: block;
}

a {
  display: flex;
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: var(--border-radius);
  background-color: var(--bg);
  color: var(--dark-text);
}

@media (hover: hover) {
    a:hover {
      background-color: var(--bg-hover);
      color: var(--dark-text);
    }
  }

a:active {
    background-color: var(--bg-active);
    color: var(--dark-text);
  }

@media (min-width: 500px) {

a {
    padding-left: 16px;
    padding-right: 16px
}
  }

main {
  flex: 1;
  min-width: 1px;
  display: flex;
  align-items: center;
}

::slotted(*) {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

ef-timeago {
  margin-left: 16px;
  color: var(--dark-text-secondary);
  font-size: var(--font-size-sm);
}
`;
export default styles;
